var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{'is-mobile': _vm.$vuetify.breakpoint.mobile},attrs:{"id":"app"}},[_c('consent-dialog',{on:{"logout":_vm.logout}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }